import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import SelectCustom from '../../../SelectCustom';

import styles from './index.styl';

const UnitField = ({
  intl,
  editMode,
  title,
  value,
  viewValue,
  options,
  onChange,
}) => {
  const { formatMessage } = intl;

  return (
    <div className={styles.unit}>
      <div className={styles.unitTitle}>{formatMessage({ id: title })}</div>
      {editMode ? (
        <SelectCustom onChange={onChange} options={options} value={value} />
      ) : (
        <div className={styles.unitValue}>
          {formatMessage({ id: viewValue })}
        </div>
      )}
    </div>
  );
};

UnitField.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  viewValue: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  editMode: PropTypes.bool,
};

export default injectIntl(UnitField);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/UnitsSettings/UnitField/index.jsx